import React from "react";
import monkeyDecor01 from "../img/01.png";
import monkeyDecor02 from "../img/02.png";
import "./MonkeyBackdrop.css";

const MONKEY_DECOR_IMAGES = [monkeyDecor01, monkeyDecor02];

const MONKEY_POSITIONS = [
  { src: MONKEY_DECOR_IMAGES[0], top: "6%", left: "4%" },
  { src: MONKEY_DECOR_IMAGES[1], top: "18%", right: "8%" },
  { src: MONKEY_DECOR_IMAGES[0], bottom: "22%", left: "10%" },
  { src: MONKEY_DECOR_IMAGES[1], bottom: "8%", right: "12%" },
  { src: MONKEY_DECOR_IMAGES[0], top: "42%", left: "2%" },
  { src: MONKEY_DECOR_IMAGES[1], top: "55%", right: "4%" },
];

const MOTION_CLASSES = ["tt-monkey--drift", "tt-monkey--sway", "tt-monkey--float"];

function MonkeyBackdrop() {
  return (
    <div className="tt-monkeys" aria-hidden>
      {MONKEY_POSITIONS.map((pos, i) => (
        <span
          key={`${pos.src}-${i}`}
          className={`tt-monkey ${MOTION_CLASSES[i % MOTION_CLASSES.length]}`}
          style={{
            top: pos.top,
            left: pos.left,
            right: pos.right,
            bottom: pos.bottom,
            animationDelay: `${i * 0.35}s`,
          }}
        >
          <img className="tt-monkey-image" src={pos.src} alt="" loading="lazy" />
        </span>
      ))}
    </div>
  );
}

export default MonkeyBackdrop;
